<template>
  <b-overlay
    :show="loading"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
  <div class="fitting-container" v-if="fittingLogs">
    
    <div class="fitting-content">
      <div class="title-line">
        <div class="left">
          <div class="fit-balise good">
              
             
              
              <span class="fit-balise-name">
               Complete

              </span>
            </div>

          Fit Report
        </div>
        <div class="right">
          <div class="right-item" v-if="glass">
            <div class="label">Model</div>
            <div class="value">{{ glass.name }}</div>
          </div>
          <div class="right-item" v-if="scan">
            <div class="label">Scan</div>
            <div class="value">{{ scan.name }}</div>
          </div>
          <div class="right-item" v-if="scan">
            <div class="label">Scan ID</div>
            <div class="value">#{{ scan.id }}</div>
          </div>
          <div class="right-item" v-if="scan">
            <div class="label">Date of scan</div>
            <div class="value">{{ scan.date }}</div>
          </div>
        </div>
      </div>
      <div class="fitting-top">
          <div class="scans-canvas"  >
            <scan-canvas v-if="scan" :scan="scan" @displayMeasurementsEv="displayMeasurements" :displayMeasures="measuresDisplay" />
       
          </div>

          <div class="fitting-info" v-if="measuresDisplay">
          <div class="button-close" @click="measuresDisplay=false">
            <img src="/assets/images/minusnew.svg" width="12" />
          </div>
          <div class="fitting-info-title">Morphological Measurements</div>
          <div class="measurement-title">Others</div>

          <div class="measurement-content">
            <span class="label">Right Nasal Face Angle :</span>
            <span class="value">{{ measurements.RightNasalFaceAngle}}</span>
          </div>
          <div class="measurement-content">
            <span class="label">Left Nasal Face Angle :</span>
            <span class="value">{{ measurements.LeftNasalFaceAngle}}</span>
          </div>
          <!--
          <div class="measurement-content">
            <span class="label">Nasal Bone Width :</span>
            <span class="value">{{ measurements.NasalWidth}}</span>
          </div>
        -->
          <div class="measurement-content">
            <span class="label">Cantus Distance:</span>
            <span class="value">{{ measurements.CantusDistance}}</span>
          </div>
         
          <div class="measurement-content">
            <span class="label">Eye to lens distance (Topological):</span>
            <span class="value">{{ measurements.EyeToLensDistance}}</span>
          </div>
          <div class="measurement-content">
            <span class="label">Temple Width:</span>
            <span class="value">{{ measurements.TempleDistance}}</span>
          </div>
          <div class="measurement-content">
            <span class="label">Sphenoidal Width :</span>
            <span class="value">{{ measurements.SpenoidalWidth}}</span>
          </div>
          <div class="measurement-content">
            <span class="label">Eyebrow Height :</span>
            <span class="value">{{ measurements.EyeBrowHeight}}</span>
          </div>
          <div class="measurement-content">
            <span class="label">Cheekbone Height :</span>
            <span class="value">{{ measurements.CheekboneHeight}}</span>
          </div>
         
          <div class="measurement-content">
            <span class="label">Nose Crete Angle :</span>
            <span class="value">{{ measurements.NoseCreteAngle}}</span>
          </div>
          <div class="measurement-content">
            <span class="label">Right Nasal Caster Angle :</span>
            <span class="value">{{ measurements.RightNasalCasterAngle}}</span>
          </div>
          <div class="measurement-content">
            <span class="label">Left Nasal Caster Angle :</span>
            <span class="value">{{ measurements.LeftNasalCasterAngle}}</span>
          </div>
          
      <br />
          <div class="measurement-title">Pupillary</div>

          <div class="measurement-content">
            <span class="label">Close Pupillary Distance:</span>
            <span class="value">{{ measurements.PupillaryDistance}}</span>
          </div>
          <div class="measurement-content">
            <span class="label">Far Pupillary Distance:</span>
            <span class="value">{{ measurements.FarPupillaryDistance ? measurements.FarPupillaryDistance : measurements.PupillaryDistance*1+4}}</span>
          </div>
          <div class="measurement-content">
            <span class="label">Pupillary Height:</span>
            <span class="value">{{ goodPupillaryHeight}}</span>
          </div>
          <div class="measurement-content">
            <span class="label">Final Eye to Lens Distance:</span>
            <span class="value">{{ goodEyeToLensDistance}}</span>
          </div>

          
        </div>
            
        
        
        <div class="fitting-description" v-else>
         
            <div class="fit-balise" :class="{'good':fittingLogs.global_score>=70,'low':fittingLogs.global_score<40,'medium':fittingLogs.global_score>=40 && fittingLogs.global_score<70}">
              
              <template v-if="fittingLogs.global_score>=70">
                <img src="/assets/images/fit-good.png" width="16" /> 
              </template>
              <template v-else-if="fittingLogs.global_score<40">
                <img src="/assets/images/fit-low.png"  width="16" /> 
              </template>
              <template v-else>
                <img src="/assets/images/fit-medium.png"  width="16" /> 
              </template>
              
              
              <span class="fit-balise-name">
                <template v-if="fittingLogs.global_score>=70">
                  Great Fit
                </template>
                <template v-else-if="fittingLogs.global_score<40">
                  Needs Adjustment
                </template>
                <template v-else>
                  Average Fit
                </template>

              </span>
            </div>
           
            <div>
            <div class="recommended">Size <span class="sizename">{{ fittingLogs.final_size }}</span> is the best match for your facial measurements.</div>
            <div class="recommended-sizes medium">
              
              <div class="size" :class="{active:fittingLogs.final_size=='xs',good:isSizeInGoodAdjustments('xs')}">
                <div class="size-content">
                  <div class="size-score" :style="{height:fittingLogs.size_feedback_result_xs.split('-')[1]+'%'}">
                   
                  </div>
                  <div class="size-name">XS</div>
                </div>
                
              </div>
              <div class="size" :class="{active:fittingLogs.final_size=='s',good:isSizeInGoodAdjustments('s')}">
                <div class="size-content">
                  <div class="size-score"  :style="{height:fittingLogs.size_feedback_result_s.split('-')[1]+'%'}">
                   
                  </div>
                  <div class="size-name">S</div>
                </div>
                
              </div>
              <div class="size" :class="{active:fittingLogs.final_size=='m',good:isSizeInGoodAdjustments('m')}">
                <div class="size-content">
                  <div class="size-score" :style="{height:fittingLogs.size_feedback_result_m.split('-')[1]+'%'}"></div>
                  <div class="size-name">M</div>
                
                </div>
                
              </div>
              <div class="size" :class="{active:fittingLogs.final_size=='l',good:isSizeInGoodAdjustments('l')}">
                <div class="size-content">
                  <div class="size-score" :style="{height:fittingLogs.size_feedback_result_l.split('-')[1]+'%'}"></div>
                  <div class="size-name">L</div>
                </div>
               
              </div>
              <div class="size" :class="{active:fittingLogs.final_size=='xl',good:isSizeInGoodAdjustments('xl')}">
                <div class="size-content">
                  <div class="size-score"  :style="{height:fittingLogs.size_feedback_result_xl.split('-')[1]+'%'}"></div>
                  <div class="size-name">XL</div>
                </div>
                
              </div>
            </div>
          </div>
          <!--<div class="desc-bottom">
            Best fit ! <span class="grey">Harciaerro et ea coria inverchici.</span>
          </div>-->
        </div>

        </div>
        <template v-if="!measuresDisplay">
          <div class="fitting-infos">
            <div class="fitting-info">
              <div class="fitting-info-title">Frame size</div>

              <div class="fit-balise little-fit-balise" :class="{'good':sizeFeedBackInfo.split('-')[1]>=70,'low':sizeFeedBackInfo.split('-')[1]<40,'medium':sizeFeedBackInfo.split('-')[1]>=40 && sizeFeedBackInfo.split('-')[1]<70}">
              
                <span class="fit-balise-name">
                  <template v-if="sizeFeedBackInfo.split('-')[1]>=70">
                  Good Size ! 
                </template>
                <template v-else-if="sizeFeedBackInfo.split('-')[1]>=40">
                  <template v-if="sizeFeedBackInfo.split('-')[0]==1">
                    Big !
                  </template>
                  <template v-else>
                    Small !
                  </template>
                
                </template>
                <template v-else>
                  <template v-if="sizeFeedBackInfo.split('-')[0]==1">
                    Too big !
                  </template>
                  <template v-else>
                    Too small !
                  </template>
                </template>

                </span>
              </div>
              
              <div class="fitting-info-range">
               
                <div class="range-content-wrap">
                  <div class="range-cursor-text" :class="{'right':sizeFeedBackInfo.split('-')[0]==1 ? ((100 - sizeFeedBackInfo.split('-')[1]) * 0.4)==50 : ((sizeFeedBackInfo.split('-')[1] - 100) * 0.4)==50,'left':sizeFeedBackInfo.split('-')[0]==1 ? ((100 - sizeFeedBackInfo.split('-')[1]) * 0.4)==50 : ((sizeFeedBackInfo.split('-')[1] - 100) * 0.4)==50}" :style="'margin-left:'+(sizeFeedBackInfo.split('-')[0]==1 ? ((100 - sizeFeedBackInfo.split('-')[1]) * 0.4)+'%' : ((sizeFeedBackInfo.split('-')[1] - 100) * 0.4)+'%')">
                    <div class="cursor-point"  :class="{'medium':sizeFeedBackInfo.split('-')[1]<70 && sizeFeedBackInfo.split('-')[1]>40,'low':sizeFeedBackInfo.split('-')[1]<=40}"></div>  
                  </div>
                  <div class="range-content">
                    <div class="range-cursor" :class="{'right':sizeFeedBackInfo.split('-')[0]==1 ? ((100 - sizeFeedBackInfo.split('-')[1]) * 0.4)==50 : ((sizeFeedBackInfo.split('-')[1] - 100) * 0.4)==50,'left':sizeFeedBackInfo.split('-')[0]==1 ? ((100 - sizeFeedBackInfo.split('-')[1]) * 0.4)==50 : ((sizeFeedBackInfo.split('-')[1] - 100) * 0.4)==50,'medium':sizeFeedBackInfo.split('-')[1]<70 && sizeFeedBackInfo.split('-')[1]>40,'low':sizeFeedBackInfo.split('-')[1]<=40}" :style="'margin-left:'+(sizeFeedBackInfo.split('-')[0]==1 ? ((100 - sizeFeedBackInfo.split('-')[1]) * 0.4)+'%' : ((sizeFeedBackInfo.split('-')[1] - 100) * 0.4)+'%')"></div>
                  </div>
                </div>

              </div>
              <div class="range-legend-ruler">
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                
              </div>
              <div class="range-legend-content">
                <div class="min-range">Small</div>
                <div class="mid-range">Good</div>
                <div class="max-range">Large</div>
              </div>
              <div class="fitting-info-content">

                <span class="grey">
                  Your pupils sit
                
                  <template v-if="sizeFeedBackInfo.split('-')[1]>=70">
                    inside 
                  </template>
                  <template v-else-if="sizeFeedBackInfo.split('-')[1]>=40">
                    near the center of 
                  </template>
                  <template v-else>
                    slightly outside 
                  </template>

                  the lens box, making the frame look 

                  <template v-if="sizeFeedBackInfo.split('-')[1]>=70">
                      well sized 
                  </template>
                  <template v-else-if="sizeFeedBackInfo.split('-')[1]>=40">
                    <template v-if="sizeFeedBackInfo.split('-')[0]==1">
                      large 
                    </template>
                    <template v-else>
                      small 
                    </template>
                  
                  </template>
                  <template v-else>
                    <template v-if="sizeFeedBackInfo.split('-')[0]==1">
                      slightly large 
                    </template>
                    <template v-else>
                      slightly small 
                    </template>
                  </template>

                  on your face</span>

                </div>
            </div>

            <div class="fitting-info">
              <div class="fitting-info-title">Frame position</div>

              <div class="fit-balise little-fit-balise" :class="{'good':framePositionInfo.split('-')[1]>=70,'low':framePositionInfo.split('-')[1]<40,'medium':framePositionInfo.split('-')[1]>=40 && framePositionInfo.split('-')[1]<70}">
              
                <span class="fit-balise-name">
                  <template v-if="framePositionInfo.split('-')[1]>=70">
                    Well Centered ! 
                  </template>
                  <template v-else-if="framePositionInfo.split('-')[1]>=40">
                    <template v-if="framePositionInfo.split('-')[0]==1">
                      High !
                    </template>
                    <template v-else>
                      Low !
                    </template>
                  
                  </template>
                  <template v-else>
                    <template v-if="framePositionInfo.split('-')[0]==1">
                      Too High !
                    </template>
                    <template v-else>
                      Too Low !
                    </template>
                  </template>

                </span>
              </div>
              
              <div class="fitting-info-range">
                
                <div class="range-content-wrap">

                  <div class="range-cursor-text" :class="{'right':framePositionInfo.split('-')[0]==1 ? ((100 - framePositionInfo.split('-')[1]) * 0.4)==50 : ((framePositionInfo.split('-')[1] - 100) * 0.4)==50,'left':framePositionInfo.split('-')[0]==1 ? ((100 - framePositionInfo.split('-')[1]) * 0.4)==-50 : ((framePositionInfo.split('-')[1] - 100) * 0.4)==-50}" :style="'margin-left:'+(framePositionInfo.split('-')[0]==1 ? ((100 - framePositionInfo.split('-')[1]) * 0.4)+'%' : ((framePositionInfo.split('-')[1] - 100) * 0.4)+'%')">
                    <div class="cursor-point"  :class="{'medium':framePositionInfo.split('-')[1]<70 && framePositionInfo.split('-')[1]>40,'low':framePositionInfo.split('-')[1]<=40}"></div>
                  </div>
                  <div class="range-content">
                    
                    <div class="range-cursor" :class="{'right':framePositionInfo.split('-')[0]==1 ? ((100 - framePositionInfo.split('-')[1]) * 0.4)==50 : ((framePositionInfo.split('-')[1] - 100) * 0.4)==50,'left':framePositionInfo.split('-')[0]==1 ? ((100 - framePositionInfo.split('-')[1]) * 0.4)==-50 : ((framePositionInfo.split('-')[1] - 100) * 0.4)==-50,'medium':framePositionInfo.split('-')[1]<70 && framePositionInfo.split('-')[1]>40,'low':framePositionInfo.split('-')[1]<=40}" :style="'margin-left:'+(framePositionInfo.split('-')[0]==1 ? ((100 - framePositionInfo.split('-')[1]) * 0.4)+'%' : ((framePositionInfo.split('-')[1] - 100) * 0.4)+'%')"></div>
                  </div>
                </div>
                
              </div>
              <div class="range-legend-ruler">
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                
              </div>
              <div class="range-legend-content">
                <div class="min-range">Low</div>
                <div class="mid-range">Well Centered</div>
                <div class="max-range">High</div>
              </div>
              <div class="fitting-info-content">

                <span class="grey">
                  
                  The frame sits 
                <template v-if="framePositionInfo.split('-')[1]>=70">
                  well centered  
                </template>
                <template v-else-if="framePositionInfo.split('-')[1]>=40">
                  <template v-if="framePositionInfo.split('-')[0]==1">
                    high 
                  </template>
                  <template v-else>
                    low 
                  </template>
                 
                </template>
                <template v-else>
                  <template v-if="framePositionInfo.split('-')[0]==1">
                    high 
                  </template>
                  <template v-else>
                    low 
                  </template>
                </template>
                 relative to your eyes.
                  
                 </span>

              </div>
            </div>
          </div>
        
        <div class="fitting-infos">
            <div class="fitting-info">
              <div class="fitting-info-title">Nose comfort</div>

              <div class="fit-balise little-fit-balise" :class="{'good':noseComfortInfo>=70,'low':noseComfortInfo<40,'medium':noseComfortInfo>=40 && noseComfortInfo<70}">
              
                <span class="fit-balise-name">
                  <template v-if="noseComfortInfo>=70">
                    Good Comfort ! 
                  </template>
                  <template v-else-if="noseComfortInfo>=40">
                  
                    Adequate !
                  </template>
                  <template v-else>
                    Needs Adjustment !
                  </template>

                </span>
              </div>
              
              <div class="fitting-info-range">
               
                <div class="range-content-wrap">
                  <div class="range-cursor-text" :class="{'right':noseComfortInfo==100,'left':noseComfortInfo==0}" :style="{ left: noseComfortInfo + '%' }">
                    <div class="cursor-point"   :class="{'medium':noseComfortInfo<70 && noseComfortInfo>40,'low':noseComfortInfo<=40,'right':noseComfortInfo==100,'left':noseComfortInfo==0}"></div>
                  </div>
                  <div class="range-content">
                  <div class="range-cursor" :class="{'medium':noseComfortInfo<70 && noseComfortInfo>40,'low':noseComfortInfo<=40,'right':noseComfortInfo==100,'left':noseComfortInfo==0}" :style="{ left: noseComfortInfo + '%' }"></div>
                  </div>
                </div>
               
              </div>

              <div class="range-legend-ruler">
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                
              </div>
              <div class="range-legend-content">
                <div class="min-range">Needs refining</div>
                <div class="mid-range">Adequate</div>
                <div class="max-range">Optimized</div>
              </div>
              
              <div class="fitting-info-content">
               
                <div class="small-ranges">
                  
                  <div class="small-range">
                    <div class="fitting-info-title-small">Face Angle Pressure</div>
                    <div class="fitting-info-range">
              
                      <div class="range-content-wrap">
                        <div class="range-cursor-text" :class="{'right':earOcclusionInfo.split('-')[1]==100,'left':earOcclusionInfo.split('-')[1]==0}" :style="{ left: earOcclusionInfo.split('-')[1] + '%' }">
                          <div class="cursor-point"  :class="{'medium':earOcclusionInfo.split('-')[1]<70 && earOcclusionInfo.split('-')[1]>40,'low':earOcclusionInfo.split('-')[1]<=40}"></div>
                        </div>
                        <div class="range-content">
                          <div class="range-cursor" :class="{'medium':earOcclusionInfo.split('-')[1]<70 && earOcclusionInfo.split('-')[1]>40,'low':earOcclusionInfo.split('-')[1]<=40,'right':earOcclusionInfo.split('-')[1]==100,'left':earOcclusionInfo.split('-')[1]==0}" :style="{ left: earOcclusionInfo.split('-')[1] + '%' }"></div>
                        </div>
                      </div>
                      
                    </div>
                    <div class="range-legend-ruler">
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      
                    </div>
                    <div class="range-legend-content">
                      <div class="min-range">Needs refining</div>
                      <div class="mid-range">Adequate</div>
                      <div class="max-range">Optimized</div>
                    </div>
                  </div>
                  <div class="small-range">
                    <div class="fitting-info-title-small">Caster angle</div>
                    <div class="fitting-info-range">
                      
                      <div class="range-content-wrap">
                        <div class="range-cursor-text" :class="{'right':earOcclusionInfo.split('-')[1]==100,'left':earOcclusionInfo.split('-')[1]==0}" :style="{ left: earOcclusionInfo.split('-')[1] + '%' }">
                          <div class="cursor-point"  :class="{'medium':earOcclusionInfo.split('-')[1]<70 && earOcclusionInfo.split('-')[1]>40,'low':earOcclusionInfo.split('-')[1]<=40}"></div>
                        </div>
                        <div class="range-content">
                          <div class="range-cursor" :class="{'medium':earOcclusionInfo.split('-')[1]<70 && earOcclusionInfo.split('-')[1]>40,'low':earOcclusionInfo.split('-')[1]<=40,'right':earOcclusionInfo.split('-')[1]==100,'left':earOcclusionInfo.split('-')[1]==0}" :style="{ left: earOcclusionInfo.split('-')[1] + '%' }"></div>
                        </div>
                      </div>
                      
                    </div>
                    <div class="range-legend-ruler">
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      
                    </div>
                    <div class="range-legend-content">
                      <div class="min-range">Needs refining</div>
                      <div class="mid-range">Adequate</div>
                      <div class="max-range">Optimized</div>
                    </div>
                  </div>
                  
                </div>
                <br />
                
                <span class="grey">
                  Nose comfort 
                  <template v-if="noseComfortInfo>=70">
                    is comfortable 
                  </template>
                  <template v-else-if="noseComfortInfo>=40">
                  
                    is adequate 
                  </template>
                  <template v-else>
                    needs adjustment 
                  </template>
                  , mainly due to face angle being 

                  <template v-if="faceAngleInfo.split('-')[1]==70">
                    slightly low
                  </template>
                  <template v-else-if="faceAngleInfo.split('-')[1]==100">
                  
                    well centered
                  </template>

                  <template v-else-if="faceAngleInfo.split('-')[1]==30">
                    
                    too high
                  </template>

                  <template v-else>
                    <template v-if="faceAngleInfo.split('-')[0]==1">
                      too low
                    </template>
                    <template v-else>
                      too high
                    </template>
                  </template>
                   & caster angle being

                   <template v-if="casterAngleInfo.split('-')[1]==70">
                    slightly back loaded
                  </template>
                  <template v-else-if="casterAngleInfo.split('-')[1]==100">
                  
                    well centered
                  </template>

                  <template v-else-if="casterAngleInfo.split('-')[1]==30">
                    
                    too front loaded
                  </template>

                  <template v-else>
                    <template v-if="casterAngleInfo.split('-')[0]==1">
                      too back loaded
                    </template>
                    <template v-else>
                      slightly front loaded
                    </template>
                  </template>
                  

                </span>

              </div>
            </div>

            <div class="fitting-info">
              <div class="fitting-info-title">Temple fit</div>

              <div class="fit-balise little-fit-balise" :class="{'good':earOcclusionInfo.split('-')[1]>=70,'low':earOcclusionInfo.split('-')[1]<40,'medium':earOcclusionInfo.split('-')[1]>=40 && earOcclusionInfo.split('-')[1]<70}">
              
                <span class="fit-balise-name">
                  <template v-if="earOcclusionInfo.split('-')[1]>=70">
                    Good ! 
                  </template>
                  <template v-else-if="earOcclusionInfo.split('-')[1]>=40">
                  
                    Adequate !
                  </template>
                  <template v-else>
                    Needs Adjustment !
                  </template>

                </span>
              </div>
              <div class="fitting-info-range">
              
                <div class="range-content-wrap">
                  <div class="range-cursor-text" :class="{'right':earOcclusionInfo.split('-')[1]==100,'left':earOcclusionInfo.split('-')[1]==0}" :style="{ left: earOcclusionInfo.split('-')[1] + '%' }">
                    <div class="cursor-point"  :class="{'medium':earOcclusionInfo.split('-')[1]<70 && earOcclusionInfo.split('-')[1]>40,'low':earOcclusionInfo.split('-')[1]<=40}"></div>
                  </div>
                  <div class="range-content">
                    <div class="range-cursor" :class="{'medium':earOcclusionInfo.split('-')[1]<70 && earOcclusionInfo.split('-')[1]>40,'low':earOcclusionInfo.split('-')[1]<=40,'right':earOcclusionInfo.split('-')[1]==100,'left':earOcclusionInfo.split('-')[1]==0}" :style="{ left: earOcclusionInfo.split('-')[1] + '%' }"></div>
                  </div>
                </div>
                
              </div>
              <div class="range-legend-ruler">
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                <div class="ruler-line">|</div>
                
              </div>
              <div class="range-legend-content">
                <div class="min-range">Needs refining</div>
                <div class="mid-range">Adequate</div>
                <div class="max-range">Optimized</div>
              </div>
              <div class="fitting-info-content">
                
                <div class="small-ranges">
                  
                  <div class="small-range">
                    <div class="fitting-info-title-small">Temple feel</div>
                    <div class="fitting-info-range">
              
                      <div class="range-content-wrap">
                        <div class="range-cursor-text" :class="{'right':earOcclusionInfo.split('-')[1]==100,'left':earOcclusionInfo.split('-')[1]==0}" :style="{ left: earOcclusionInfo.split('-')[1] + '%' }">
                          <div class="cursor-point"  :class="{'medium':earOcclusionInfo.split('-')[1]<70 && earOcclusionInfo.split('-')[1]>40,'low':earOcclusionInfo.split('-')[1]<=40}"></div>
                        </div>
                        <div class="range-content">
                          <div class="range-cursor" :class="{'medium':earOcclusionInfo.split('-')[1]<70 && earOcclusionInfo.split('-')[1]>40,'low':earOcclusionInfo.split('-')[1]<=40,'right':earOcclusionInfo.split('-')[1]==100,'left':earOcclusionInfo.split('-')[1]==0}" :style="{ left: earOcclusionInfo.split('-')[1] + '%' }"></div>
                        </div>
                      </div>
                      
                    </div>
                    <div class="range-legend-ruler">
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      
                    </div>
                    <div class="range-legend-content">
                      <div class="min-range">Needs refining</div>
                      <div class="mid-range">Adequate</div>
                      <div class="max-range">Optimized</div>
                    </div>
                  </div>
                  <div class="small-range">
                    <div class="fitting-info-title-small">Length</div>
                    <div class="fitting-info-range">
              
                      <div class="range-content-wrap">
                        <div class="range-cursor-text" :class="{'right':earOcclusionInfo.split('-')[1]==100,'left':earOcclusionInfo.split('-')[1]==0}" :style="{ left: earOcclusionInfo.split('-')[1] + '%' }">
                          <div class="cursor-point"  :class="{'medium':earOcclusionInfo.split('-')[1]<70 && earOcclusionInfo.split('-')[1]>40,'low':earOcclusionInfo.split('-')[1]<=40}"></div>
                        </div>
                        <div class="range-content">
                          <div class="range-cursor" :class="{'medium':earOcclusionInfo.split('-')[1]<70 && earOcclusionInfo.split('-')[1]>40,'low':earOcclusionInfo.split('-')[1]<=40,'right':earOcclusionInfo.split('-')[1]==100,'left':earOcclusionInfo.split('-')[1]==0}" :style="{ left: earOcclusionInfo.split('-')[1] + '%' }"></div>
                        </div>
                      </div>
                      
                    </div>
                    <div class="range-legend-ruler">
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      <div class="ruler-line">|</div>
                      
                    </div>
                    <div class="range-legend-content">
                      <div class="min-range">Needs refining</div>
                      <div class="mid-range">Adequate</div>
                      <div class="max-range">Optimized</div>
                    </div>
                  </div>
                  
                </div>
                <br />
                <span class="grey">
                  Ear comfort 
                  <template v-if="earOcclusionInfo.split('-')[1]>=70">
                    is well adjusted
                  </template>
                  <template v-else-if="earOcclusionInfo.split('-')[1]>=40">
                  
                    is adequate 
                  </template>
                  <template v-else>
                    needs adjustment 
                  </template>
                  - temples feel 

                  <template v-if="earOcclusionInfo.split('-')[1]>50">
                    secure
                  </template>
                  <template v-else-if="earOcclusionInfo.split('-')[1]>40">
                  
                    tight
                  </template>

                  <template v-else>
                    
                    loose
                  </template>
                  
                 <!-- and the length is 
                  <template v-if="templeLengthInfo.split('-')[1]>60">
                    good
                  </template>
                  <template v-else-if="templeLengthInfo.split('-')[1]>40">
                  
                    long
                  </template>

                  <template v-else>
                    
                    short
                  </template>.-->
                  <br />
                  *This frame has adjustable temples

                </span>
              </div>
            </div>
          </div>
        </template>
      
 
      </div>
  
    </div>
  </b-overlay>
</template>

<script>

import {BModal, BButton,BOverlay, VBModal, BRow, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest, Woocommerce} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import ScanPopup from '../../components/ScanPopup.vue'
import PrescriptionPopup from '../../components/PrescriptionPopup.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import emitter from 'tiny-emitter/instance'
import ScanCanvas from './ScanCanvasNew.vue'
import ScanViewer from './ScanViewer.vue'


export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BOverlay,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    BRow,
    ScanPopup,
    PrescriptionPopup,
    ScanCanvas,
    ScanViewer
  },
  data() {
    return {
      scan:null,
      sizeFeedBackInfo:null,
      goodAdjustments:null,
      goodEyeToLensDistance:null,
      goodPupillaryHeight:null,
      framePositionInfo:null,
      noseComfortInfo:null,
      faceAngleInfo:null,
      casterAngleInfo:null,
      earFitInfo:null,
      earOcclusionInfo:null,
      templeLengthInfo:null,
      selectedScan:localStorage.senseye_b2b_selected_scan,
      loading:true,
      measurements:null,
      fittingLogs:null,
      recommendedSize:"S",
      globalFitScore:"medium",
      XSScore:null,
      SScore:null,
      MScore:null,
      LScore:null,
      XLScore:null,
      frameSizeNegativeXS:null,
      frameSizeNegativeS:null,
      frameSizeNegativeM:null,
      frameSizeNegativeL:null,
      frameSizeNegativeXL:null,
      framePositionNegativeXS:null,
      framePositionNegativeS:null,
      framePositionNegativeM:null,
      framePositionNegativeL:null,
      framePositionNegativeXL:null,
      noseComfortNegativeXS:null,
      noseComfortNegativeS:null,
      noseComfortNegativeM:null,
      noseComfortNegativeL:null,
      noseComfortNegativeXL:null,
      earOcclusionNegativeXS:null,
      earOcclusionNegativeS:null,
      earOcclusionNegativeM:null,
      earOcclusionNegativeL:null,
      earOcclusionNegativeXL:null,
      frameSizeResultXS:null,
      frameSizeResultS:null,
      frameSizeResultM:null,
      frameSizeResultL:null,
      frameSizeResultXL:null,
      framePositionResultXS:null,
      framePositionResultS:null,
      framePositionResultM:null,
      framePositionResultL:null,
      framePositionResultXL:null,
      noseComfortResultXS:null,
      noseComfortResultS:null,
      noseComfortResultM:null,
      noseComfortResultL:null,
      noseComfortResultXL:null,
      earOcclusionResultXS:null,
      earOcclusionResultS:null,
      earOcclusionResultM:null,
      earOcclusionResultL:null,
      earOcclusionResultXL:null,
      measuresDisplay:false,
      scanUrl:''
    }
  },
  
  methods:{
    displayMeasurements() {
      this.measuresDisplay=true
    },
    isSizeInGoodAdjustments(size) {
      if (!this.goodAdjustments || !Array.isArray(this.goodAdjustments)) return false;
      if (size === undefined || size === null) return false;
      const normalizedSize = String(size).trim().toLowerCase();
      return this.goodAdjustments.some(item => String(item).trim().toLowerCase() === normalizedSize);
    },
   
    async getScan() {
      let scan=await APIRequest.detail('scans',this.$route.params.id)
      this.scan={}
      this.scanUrl='http://35.180.177.138:8080/scans/proc/'+scan.id+'.fbx'
    
      this.scan=scan
  

      if(scan.measurements)
      {
        let measurements=scan.measurements.replace('."',',"')
        measurements=measurements.replace('."',',"')
        measurements=measurements.replace('."',',"')
        measurements=measurements.replace('."',',"')

    
        
        
    
        this.measurements=JSON.parse(measurements)
      }
      
   
      //import data from "/Users/Documents/workspace/test.json"
    },
    async getFittingLogs() {
      let scan=await APIRequest.list_with_request('fitting-results','?scan='+this.$route.params.id+'&glass=58&limit=1')
       
      this.goodAdjustments=scan[0][0].good_adjustments.split('-')
      
      if(scan[0][0].final_size=='xs')
      {
        this.sizeFeedBackInfo=scan[0][0].size_feedback_result_xs
        this.framePositionInfo=scan[0][0].frame_position_result_xs
        this.noseComfortInfo=scan[0][0].nose_fit_result_xs
        this.faceAngleInfo=scan[0][0].face_angle_result_xs
        this.casterAngleInfo=scan[0][0].caster_angle_result_xs
        this.earFitInfo=scan[0][0].ear_fit_result_xs
        this.earOcclusionInfo=scan[0][0].ear_occlusion_result_xs
        this.templeLengthInfo=scan[0][0].temple_length_result_xs
        this.goodEyeToLensDistance=scan[0][0].eye_to_lens_distance_xs
        this.goodPupillaryHeight=scan[0][0].pupillary_height_xs
      }
      else if(scan[0][0].final_size=='s')
      {
        this.sizeFeedBackInfo=scan[0][0].size_feedback_result_s
        this.framePositionInfo=scan[0][0].frame_position_result_s
        this.noseComfortInfo=scan[0][0].nose_fit_result_s
        this.faceAngleInfo=scan[0][0].face_angle_result_s
        this.casterAngleInfo=scan[0][0].caster_angle_result_s
        this.earFitInfo=scan[0][0].ear_fit_result_s
        this.earOcclusionInfo=scan[0][0].ear_occlusion_result_s
        this.templeLengthInfo=scan[0][0].temple_length_result_s
        this.goodEyeToLensDistance=scan[0][0].eye_to_lens_distance_s
        this.goodPupillaryHeight=scan[0][0].pupillary_height_s
      }
      else if(scan[0][0].final_size=='m')
      {
        this.sizeFeedBackInfo=scan[0][0].size_feedback_result_m
        this.framePositionInfo=scan[0][0].frame_position_result_m
        this.noseComfortInfo=scan[0][0].nose_fit_result_m
        this.faceAngleInfo=scan[0][0].face_angle_result_m
        this.casterAngleInfo=scan[0][0].caster_angle_result_m
        this.earFitInfo=scan[0][0].ear_fit_result_m
        this.earOcclusionInfo=scan[0][0].ear_occlusion_result_m
        this.templeLengthInfo=scan[0][0].temple_length_result_m
        this.goodEyeToLensDistance=scan[0][0].eye_to_lens_distance_m
        this.goodPupillaryHeight=scan[0][0].pupillary_height_m
      }
      else if(scan[0][0].final_size=='l')
      {
        this.sizeFeedBackInfo=scan[0][0].size_feedback_result_l
        this.framePositionInfo=scan[0][0].frame_position_result_l
        this.noseComfortInfo=scan[0][0].nose_fit_result_l
        this.faceAngleInfo=scan[0][0].face_angle_result_l
        this.casterAngleInfo=scan[0][0].caster_angle_result_l
        this.earFitInfo=scan[0][0].ear_fit_result_l
        this.earOcclusionInfo=scan[0][0].ear_occlusion_result_l
        this.templeLengthInfo=scan[0][0].temple_length_result_l
        this.goodEyeToLensDistance=scan[0][0].eye_to_lens_distance_l
        this.goodPupillaryHeight=scan[0][0].pupillary_height_l
      }
      else if(scan[0][0].final_size=='xl')
      {
        this.sizeFeedBackInfo=scan[0][0].size_feedback_result_xl
        this.framePositionInfo=scan[0][0].frame_position_result_xl
        this.noseComfortInfo=scan[0][0].nose_fit_result_xl
        this.faceAngleInfo=scan[0][0].face_angle_result_xl
        this.casterAngleInfo=scan[0][0].caster_angle_result_xl
        this.earFitInfo=scan[0][0].ear_fit_result_xl
        this.earOcclusionInfo=scan[0][0].ear_occlusion_result_xl
        this.templeLengthInfo=scan[0][0].temple_length_result_xl
        this.goodEyeToLensDistance=scan[0][0].eye_to_lens_distance_xl
        this.goodPupillaryHeight=scan[0][0].pupillary_height_xl
      }
      this.fittingLogs=scan[0][0]
   

      //import data from "/Users/Documents/workspace/test.json"
    },
    selectScan(id) {
      this.selectedScan=this.scan.id
      localStorage.senseye_b2b_selected_scan=this.scan.id
   
    },
    
    
  },
  watch:{
    
  },
  async mounted()
  {
    if(this.$route.params.token)
    {
      localStorage.token_senseye_auth=this.$route.params.token
    }
    this.loading=true
    
    
    await this.getFittingLogs()
    await this.getScan()
    this.loading=false
  }
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';

.measurement-title
{
  border-radius: 5px;
  background:#63ff2b;
  padding:5px 15px;
  width: fit-content;
  margin-bottom:10px;
}
.measurement-content .label 
{
  color:#999;
}
.measurement-content
{
  display:flex;
  flex-direction: row;
  
  align-items: center;
  justify-content: space-between;
}
.fitting-info-content .grey
{
  color:#999;
}
.fitting-info-content
{
  background:#f1f1f1;
  padding:9px 18px;
  margin-top:10px;
  border-radius: 5px;
}
.fitting-info-title
{
  font-size:16px;
  margin-bottom:20px;
 
}
.button-close
{
  padding:7px 12px;
  border-radius: 5px;
  background:#fff;
  position:absolute;
  right:20px;
  top:20px;
  cursor:pointer;
}
.little-fit-balise
{
  position:absolute;
  top:0;
  padding:5px 7px !important;
  right:0;
}
.fitting-info 
{
  width:50%;
 
  position:relative;
}
.cursor-point.low,.range-cursor.low 
{
  background:#FF9900;
}
.cursor-point.good,.range-cursor.good 
{
  background:#2AC770;
}
.cursor-point.medium,.range-cursor.medium 
{
  background:#0088FF;
}

.cursor-point
{
  width:10px;
  height:10px;
  border-radius: 50%;
  position:absolute;
  top:50%;
  left:50%;
  transform: translate(-50%,-50%);
  background:#2AC770;
}
.range-cursor-text .text
{
  min-width:100px;
  text-align: center;
  position:absolute;
 
  left:50%;
  transform: translateX(-50%);
 
}
.range-cursor-text 
{
  width:20%;

  text-align: center;
  position:absolute;
  top:2px;
  left:50%;
  transform: translateX(-50%);
  font-size:12px;
  line-height:14px;
}
.range-cursor-text.right
{
  transform: translateX(-100%);
}
.range-cursor.right
{
  transform: translateX(-100%);
}
.range-cursor.left,.range-cursor-text.left
{
  transform: none;
}
.range-cursor 
{
  width:20%;
  position:absolute;
  top:0;
  left:50%;
  transform: translateX(-50%);
  height:100%;
  background:#2AC770;
}
.fitting-infos 
{
  margin-top:20px;
  display:flex;
  flex-direction: row;
  align-items: flex-start;
  gap:20px;
  width:100%;
}
.desc-bottom .grey
{
  color:#999;
}
.range-content-wrap 
{
  flex:1;



  position:relative;
}
.range-content 
{
  flex:1;
  height:3px;
  overflow:hidden;
  background:#99999930;
  border-radius: 5px;
  position:relative;
}
.fitting-info-range 
{
  margin-top:25px;
  display:flex;
  flex-direction: row;
  gap:20px;
  color:#999;
  width:100%;
  font-size:12px;
  align-items: center;
  justify-content: center;
}
.desc-bottom 
{
  padding:5px 10px;
  border-radius: 5px;
  background:#f1f1f1;
  margin-top:10px;
}
.fit-balise.good 
{
  background:#DBF6E7;
  color:#10C05F;
}
.fit-balise.low 
{
  background:#FFF0D9;
  color:#FF9900;
}
.fit-balise.medium 
{
  color:#0088FF;
  background:#D9EDFF;
}
.sizename
{
  text-transform: uppercase;
}
.right-item .label
{
  color:#999;
}
.fit-balise 
{
  margin-bottom:0px;
  width:fit-content;
  display:flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap:10px;
  padding:9px 10px;
  border-radius: 5px;
}
.title-line .left .fit-balise
{
  font-size:12px;
  margin-bottom: 0 !important;
}
.title-line .left
{
  font-size:40px;
}
.title-line .right
{
  display:flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap:20px;
}
.title-line .right-item
{
  display:flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

}
.title-line
{
  display:flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  width:100%;
  margin-bottom:20px;
}
.size.active .size-name 
{
  background:#fff;

}
.size-name 
{
  background:#ececec;
  padding:5px 10px;
  color:#000;
  border-radius: 5px;
  left:50%;
  transform: translateX(-50%);
  position:absolute;
  bottom:10px;
}
.size.good .size-score
{
  background-color: #63ff2b30;
}
.size.active .size-score
{
  background-color: #63ff2b;
}
.size-score
{
  border-radius: 5px;
 
  position:absolute;
  bottom:0;
  width:100%;
  background-color: #99999930;
}
.size
{
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap:10px;
}
.size-content
{
  border-radius: 5px;

  width:56px;
  height:180px;
  position:relative;
  background-color: #f1f1f1;
}
.trait 
{
  position:absolute;
  left:0;
  top:144px;
  width:100%;
  height:1px;
  background-color: #999;
}
.recommended-sizes
{
  padding-top: 20px;
  display:flex;
  flex-direction: row;
  gap:10px;
  position:relative;
  justify-content: center;
  min-height:165px;
}
.fitting-container
{
  font-weight:400;
  font-family:"degular";
  color:#000;
  font-size:12px;
 background-color: #fff;
 min-height:100vh;
 padding-bottom:50px;
}
.fitting-content
{
  display:flex;
  max-width:964px ;
  flex-direction: column;
  width:80%;
  margin-left: auto;
  margin-right: auto;
  padding-top: 50px;
}
.fitting-top
{
  gap:0px;
  display:flex;
  flex-direction: row;
  width:100%;
  background:#f1f1f1;
 
  border-radius: 5px;
}
.recommended
{
  color:#000;

}
.range-legend-content .max-range
{
  text-align: right;
}
.range-legend-content .mid-range
{
  position:absolute;
  left:50%;
  transform: translateX(-50%);
}
.range-legend-content
{
  position:relative;
  display: flex;
  width:100%;
  justify-content: space-between;
  gap:14px;
  color:#999;
  overflow:hidden;
}
.small-ranges .range-legend-ruler
{
  gap:5px !important;
}
.small-ranges .range-legend-content
{
  font-size:10px;
}
.small-range
{
  width:50%;
}
.small-ranges 
{
  display:flex;

  gap:10px;
}
.range-legend-ruler
{
  width:100%;
  display: flex;
  justify-content: center;
  gap:14px;
  color:#999;
  overflow:hidden;
  margin-top:10px;
  margin-bottom:10px;
}
.fitting-description
{
 
  display:flex;
  margin-top:20px;
  margin-right:20px;
  margin-bottom:20px;
  background:#fff;
  padding:20px;
  border-radius: 5px;
  justify-content: space-between;
  flex-direction: column;

  width: 50%;
}
.scans-canvas
{
  display:flex;
  width:55%;
  flex-direction: row;
  height:100%;
  border-radius: 5px;
 
}

.overlay-scan {
  width:100%;
  height:100vh;
  z-index:999999;
}
#element-to-convert
{
  padding-left:20px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}
</style>
